module.exports = __webpack_public_path__ + "static/img/home_car.c31dc1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/home_car.png
// module id = 7l/B
// module chunks = 1